import { catchError, map } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";
import { Observable } from "rxjs";

import { UserService } from "../../shared/user.service";
import { CommunityService } from "../community.service";
import { Community } from "../../../models";

@Injectable()
export class EditableCommunityResolver implements Resolve<Community> {
  constructor(
    private communityService: CommunityService,
    private router: Router,
    private userService: UserService
  ) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.communityService.findOne(route.params["communityName"]).pipe(
      map((community: Community) => {
        if (
          this.userService.getCurrentUser().username ===
          community.founder.username
        ) {
          return community;
        } else {
          this.router.navigateByUrl("/");
        }
      }),
      catchError((err) => this.router.navigateByUrl("/"))
    );
  }
}
